module.exports = __webpack_public_path__ + "img/fbgl.164a6e7d.png";